@if (
  {
    isOnline: isOnline$ | async,
    text: text$ | async,
  };
  as state
) {
  <div>
    @if (state.isOnline) {
      <span class="online">
        <i class="material-icons online_bubble">fiber_manual_record</i>
        <span class="online_text" [textContent]="state.text"></span>
      </span>
    }
    @if (!state.isOnline) {
      <span [textContent]="state.text"></span>
    }
  </div>
}
